import apiService from './api';

const familyPlanningCatalogService = {
  list(params = {}) {
    return apiService.get('/family-planning-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/family-planning-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/family-planning-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/family-planning-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/family-planning-catalog/${id}`);
  }
};

export default familyPlanningCatalogService;
